import * as React from 'react';

import { Dialog, type DialogProps, FullscreenDialog, type FullscreenDialogProps } from '@coursera/cds-core';

import { DisableFocusLockProvider, useDisableFocusLock } from 'bundles/asset-admin/context/DisableFocusLockContext';

const CdsFullscreenDialogWithFocusOverride = ({
  children,
  disableFocusLock: disableFocusLockFromProps,
  ...props
}: React.PropsWithChildren<FullscreenDialogProps>) => {
  const context = useDisableFocusLock();
  return (
    <FullscreenDialog {...props} disableFocusLock={context?.disableFocusLock ?? disableFocusLockFromProps}>
      {children}
    </FullscreenDialog>
  );
};

const FullScreenDialogWithFocusOverrideProvider = ({
  children,
  ...props
}: React.PropsWithChildren<FullscreenDialogProps>) => (
  <DisableFocusLockProvider>
    <CdsFullscreenDialogWithFocusOverride {...props}>{children}</CdsFullscreenDialogWithFocusOverride>
  </DisableFocusLockProvider>
);

const DialogWithFocusOverride = ({
  children,
  disableFocusLock: disableFocusLockFromProps,
  ...props
}: React.PropsWithChildren<DialogProps>) => {
  const context = useDisableFocusLock();
  return (
    <Dialog {...props} disableFocusLock={context?.disableFocusLock ?? disableFocusLockFromProps}>
      {children}
    </Dialog>
  );
};

export const DialogWithFocusOverrideProvider = ({ children, ...props }: React.PropsWithChildren<DialogProps>) => (
  <DisableFocusLockProvider>
    <DialogWithFocusOverride {...props}>{children}</DialogWithFocusOverride>
  </DisableFocusLockProvider>
);

export default FullScreenDialogWithFocusOverrideProvider;
